(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && Shopify.money_format) {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function updateFreeShippingBars(cart) {
    document.querySelectorAll('[data-free-shipping-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold) return;

      var total = cart.total_price;
      var remaining = threshold - total;
      var percentage = threshold > 0 ? (total * 100) / threshold : 0;
      if (percentage > 100) percentage = 100;
      if (percentage < 0) percentage = 0;

      bar.style.setProperty('--progress-width', percentage + '%');

      var fill = bar.querySelector('[data-free-shipping-fill]');
      if (fill) fill.style.width = percentage + '%';

      var textEl = bar.querySelector('[data-free-shipping-text]');
      var rightEl = bar.querySelector('[data-free-shipping-remaining-right]');
      var remainingMoney = formatMoney(Math.max(remaining, 0));

      if (remaining > 0) {
        if (textEl) {
          textEl.innerHTML =
            bar.dataset.messageBefore +
            '<span class="price-highlight-drawer" data-free-shipping-remaining>' + remainingMoney + '</span>' +
            bar.dataset.messageAfter;
        }
        if (rightEl) rightEl.textContent = remainingMoney;
      } else {
        if (textEl) textEl.textContent = bar.dataset.successMessage;
        if (rightEl) rightEl.textContent = '';
      }
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(updateFreeShippingBars)
      .catch(function (err) { console.error('Free shipping bar update error:', err); });
  }

  // Existing theme event (cart-drawer carousel reinit isi pe hota hai)
  document.addEventListener('theme:cartchanged', fetchCartAndUpdate);
  // Generic fallback — agar koi aur script isse dispatch karta hai
  document.addEventListener('cart:updated', fetchCartAndUpdate);

  // Existing eventBus pattern jo cart-upsell add mein use ho raha hai
  if (window.eventBus && typeof window.eventBus.on === 'function') {
    window.eventBus.on('update:cart:drawer', function (cartData) {
      if (cartData && typeof cartData.total_price !== 'undefined') {
        updateFreeShippingBars(cartData);
      } else {
        fetchCartAndUpdate();
      }
    });
  }
})();